import { SustainabilityCardComponent } from '../../../components/common/sustainability-card/sustainability-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, SustainabilityCardComponent],
  selector: 'app-policy-already-enrolled',
  templateUrl: './policy-already-enrolled.component.html',
  styleUrls: ['./policy-already-enrolled.component.scss']
})
export class PolicyAlreadyEnrolledComponent {

}
